<template>
  <div>
    <div class="lecture-card-list">
      <div class="filter-buttons">
        <button :class="{ active: filter === 'notViewed' }" @click="filter = 'notViewed'">시청전</button>
        <button :class="{ active: filter === 'viewed' }" @click="filter = 'viewed'">시청완료</button>
      </div>

      <div class="count-text">총 {{ filteredData.length }}건</div>

      <div v-for="(item, index) in filteredData" :key="index" class="lecture-card">
        <div class="info-left">
          <div class="v-title">{{ item.title }}</div>
          <div class="sub">동영상 시청 날짜: {{ setTableDateFormat(item.watchedTime) }}</div>
          <div class="sub">동영상 시간: {{ item.playTime }}</div>
        </div>
        <div class="info-right">
          <button class="watch-button al-center" @click="openVideoPlayer(item)">
            <span class="button-text al-center">동영상 시청</span>
            <img src="@/assets/images/icons/lectures_collection_icon.png" alt="재생" class="button-icon" />
          </button>
          <div class="status al-center" :class="item.watchedYn === 'Y' ? 'done' : ''">
            {{ item.watchedYn === 'Y' ? '시청완료' : '시청 전' }}
          </div>
        </div>
      </div>
    </div>

    <!-- 팝업 컴포넌트 -->
    <lecture-player-popup
      :isOpen="isPlayerOpen"
      :videoDataProps="selectedVideo"
      @close="closePlayer"
    />
  </div>
</template>

<script>
import LecturePlayerPopup from "@/pages/Lecture/popup/LecturePlayerPopup.vue";
import _ from "lodash";
import {axiosInstance} from "@/util/AxiosModule";
import {mapGetters} from "vuex";
import DateMixin from "@/mixin/DateMixin";

export default {
  name: "LectureCardList",
  components: { LecturePlayerPopup },
  props: ["data"],
  mixins: [DateMixin],
  data() {
    return {
      filter: "notViewed",
      isPlayerOpen: false,
      selectedVideo: {}
    };
  },
  computed: {
    ...mapGetters("login", {
      memberId: "memberId"
    }),
    filteredData() {
      if (!_.isEmpty(this.data)) {
        return this.data.filter((item) => {
          return this.filter === "viewed" ? item.watchedYn === "Y" : item.watchedYn === "N";
        });
      }
      return [];
    },
  },
  methods: {
    openVideoPlayer(item) {
      if (!item.url.includes("youtube")) {
        alert("유효한 YouTube 링크가 아닙니다");
        return;
      }
      this.selectedVideo = item;
      this.isPlayerOpen = true;
      this.videoContractHistSave();
    },
    async videoContractHistSave() {
      try {
        await axiosInstance.put("/private/operation/contract-hist", {}, {
          params: {
            memberId: this.memberId,
            usageType: "training",
            usageId: this.selectedVideo.trainingId
          }
        }).then(() => {
          console.log(`${this.selectedVideo.trainingId}번 영상에 대한 이력 저장 성공`);
        })
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    closePlayer() {
      this.$emit("refresh");
      this.isPlayerOpen = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.al-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.lecture-card-list {
  padding: 16px;
}

.filter-buttons {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.filter-buttons button {
  padding: 8px 25px;
  border: 1px solid #ccc;
  background: white;
  cursor: pointer;

  border-radius: 20px;
}

.filter-buttons .active {
  background: black;
  color: white;
}

.count-text {
  margin-bottom: 12px;
}

.lecture-card {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #ccc;
  padding: 16px 0;
}

.info-left, .info-right {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.info-left {
  .v-title {
    font-size: 24px;
    font-weight: bold;
  }
  .sub {
    font-size: 16px;
    margin-top: 4px;
  }
}

.info-right {
  text-align: right;

  .watch-button {
    width: 130px;
    background-color: #f0f0f0;
    margin-bottom: 4px;
    border-radius: 4px;
    cursor: pointer;

    .button-text {
      height: 40px;
      font-size: 20px;
      font-weight: bold;
    }
    .button-icon {
      height: 35px;
      width: 35px;
      display: none;
    }
  }

  .watch-button:hover {
    color: #306EBB;
  }

  .status {
    height: 40px;
    font-size: 20px;
    //padding: 4px 35px;
    text-align: center;
    border: 1px solid #e2e2e2;
    border-radius: 6px;
  }
  .status.done {
    background: #306EBB;
    color: white;
  }

}

@media screen and (max-width: 980px) {

  .info-left{
    .v-title {
      font-size: min(4.8vw, 24px);
    }
    .sub {
      font-size: min(3.2vw, 16px);
      margin-top: min(0.8vw, 4px);
    }
  }

  .info-right {

    .watch-button {
      width: min(20vw, 130px);
      //height: min(8vw, 40px);

      .button-text {
        display: none;
      }
      .button-icon {
        display: inline-block;
      }
    }

    .status {
      width: min(20vw, 130px);
      font-size: min(3.4vw, 17px);
    }
  }
}

</style>
